(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  'use strict';
var $197cd56b15c33885$var$CLASSNAME = Object.freeze({
    Start: 'start',
    Restart: 'restart',
    Hidden: 'hidden',
    ActionButton: 'button'
});
var $197cd56b15c33885$var$LABEL = Object.freeze({
    Start: 'Start',
    Restart: 'Restart'
});
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


'use strict';
// required for jest to work correctly
$parcel$global.structuredClone = function(val) {
    return JSON.parse(JSON.stringify(val));
};
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_initialState = _ref.initialState, initialState = _ref_initialState === void 0 ? null : _ref_initialState, _ref_startTilesAmount = _ref.startTilesAmount, startTilesAmount = _ref_startTilesAmount === void 0 ? Game.START_TILES_QUANTITY_DEFAULT : _ref_startTilesAmount, _ref_forcePowerOfTwo = _ref.forcePowerOfTwo, forcePowerOfTwo = _ref_forcePowerOfTwo === void 0 ? false : _ref_forcePowerOfTwo;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        /**
   * Represents current {@link Game.STATUS|status} of the game
   * @type {keyof typeof Game.STATUS}
   * @private
   * @default Game.STATUS.Idle
   */ (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(this, "_status", Game.STATUS.Idle);
        /**
   * Represents current score of the game
   * @type {number}
   * @private
   */ (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(this, "_score", 0);
        /**
   * Represents the current state (grid) of the game.
   *
   * The grid is stored as a 2D array where each element represents a tile.
   * Empty tiles are represented by `0`, while others contain powers of two.
   *
   * @type {number[][]}
   * @private
   */ (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(this, "_state", void 0);
        var init = Game.sanitizeState(initialState || structuredClone(Game.DEFAULT_BOARD), forcePowerOfTwo);
        this._state = init;
        this.initialState = structuredClone(init);
        this.startTilesAmount = startTilesAmount;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            /**
   * Starts the game, setting:
   * - the {@link Game._status|status} to {@link Game.STATUS.Playing|`playing`}
   *
   * Places new tiles on the board. The number of tiles placed at the start is
   * determined by the `startTilesAmount` property.
   */ key: "start",
            value: function start() {
                this._status = Game.STATUS.Playing;
                for(var i = 0; i < this.startTilesAmount; i++)this.placeNewTile();
            }
        },
        {
            /**
   * Restarts the game, resetting:
   * - the {@link Game._score|score} to `0`,
   * - the {@link Game._state|state} to {@link DEFAULT_BOARD|default}
   * - the {@link Game._status|status} to {@link Game.STATUS.Idle|`Idle`}
   */ key: "restart",
            value: function restart() {
                this._state = structuredClone(this.initialState);
                this._status = Game.STATUS.Idle;
                this._score = 0;
            // this.start();
            }
        },
        {
            key: "size",
            get: // #region get (something)
            /**
   * Utility getter, used to get current board size (n*n)
   * @returns {number}
   */ function get() {
                return this._state.length;
            }
        },
        {
            /**
   * Returns {@link Game._score|current score} of the game
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this._score;
            }
        },
        {
            /**
   * Returns {@link Game._state|current state} (grid) of the game
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this._state;
            }
        },
        {
            /**
   * Returns {@link Game._status|current status} of the game
   * @returns {string}
   */ key: "getStatus",
            value: function getStatus() {
                return this._status;
            }
        },
        {
            // #endregion
            // #region move handlers
            key: "move",
            value: function move(key) {
                if (this._status !== Game.STATUS.Playing) return;
                switch(key){
                    case 'ArrowUp':
                        this.moveUp();
                        break;
                    case 'ArrowRight':
                        this.moveRight();
                        break;
                    case 'ArrowDown':
                        this.moveDown();
                        break;
                    case 'ArrowLeft':
                        this.moveLeft();
                        break;
                }
            }
        },
        {
            key: "handleMove",
            value: function handleMove() {
                if (this._status !== Game.STATUS.Playing) return;
                var prevState = structuredClone(this._state);
                for(var col = 0; col < this.size; col++){
                    var numbers = [];
                    for(var row = 0; row < this.size; row++)if (this._state[row][col] !== 0) numbers.push(this._state[row][col]);
                    var merged = [];
                    var i = 0;
                    while(i < numbers.length)if (i + 1 < numbers.length && numbers[i] === numbers[i + 1]) {
                        var stackedNumber = numbers[i] * 2;
                        merged.push(stackedNumber);
                        this._score += stackedNumber;
                        i += 2;
                    } else {
                        merged.push(numbers[i]);
                        i++;
                    }
                    while(merged.length < this.size)merged.push(0);
                    for(var row1 = 0; row1 < this.size; row1++)this._state[row1][col] = merged[row1];
                }
                var hasChanged = this._state.some(function(row, rowIndex) {
                    return row.some(function(cell, colIndex) {
                        return cell !== prevState[rowIndex][colIndex];
                    });
                });
                if (hasChanged) this.placeNewTile();
                this.updateGameStatus();
            }
        },
        {
            /**
   * Handles the `ArrowUp` keypress
   */ key: "moveUp",
            value: function moveUp() {
                this.handleMove();
            }
        },
        {
            /**
   * Handles the `ArrowUp` keypress, rotating the grid 180°,
   * applying the handler and rotating the grid back
   */ key: "moveDown",
            value: function moveDown() {
                this.reverseGrid();
                this.handleMove();
                this.reverseGrid();
            }
        },
        {
            /**
   * Handles the `ArrowLeft` keypress
   * and performing the same action as {@link Game.moveDown|moveDown()}, by
   * rotating the matrix by 90° clockwise
   */ key: "moveLeft",
            value: function moveLeft() {
                this.rotateClockwise();
                this.handleMove();
                this.rotateCounterClockwise();
            }
        },
        {
            /**
   * Handles the `ArrowRight` keypress
   * and performing the same action as {@link Game.moveDown|moveDown()}, by
   * rotating the matrix by 90° counterclockwise
   */ key: "moveRight",
            value: function moveRight() {
                this.rotateCounterClockwise();
                this.handleMove();
                this.rotateClockwise();
            }
        },
        {
            /**
   * Reverses the order of rows in the grid.
   *
   * Used as a helper method in grid rotation.
   */ key: "reverseGrid",
            value: function reverseGrid() {
                this._state.reverse();
            }
        },
        {
            /**
   * Transposes the grid by swapping rows and columns.
   *
   * This method is used for rotating the grid by converting rows into columns.
   */ key: "transpose",
            value: function transpose() {
                var ref;
                for(var i = 0; i < this.size; i++)for(var j = i + 1; j < this.size; j++)ref = [
                    this._state[j][i],
                    this._state[i][j]
                ], this._state[i][j] = ref[0], this._state[j][i] = ref[1], ref;
            }
        },
        {
            /**
   * Rotates the grid 90° clockwise.
   *
   * This is done by {@link Game.transpose|transposing}
   * the grid and then {@link Game.reverseGrid|reversing} each row.
   */ key: "rotateClockwise",
            value: function rotateClockwise() {
                this.transpose();
                this._state.forEach(function(row) {
                    return row.reverse();
                });
            }
        },
        {
            /**
   * Rotates the grid 90° counterclockwise.
   *
   * This is done by {@link Game.transpose|transposing}
   * the grid and then {@link Game.reverseGrid|reversing} each row.
   */ key: "rotateCounterClockwise",
            value: function rotateCounterClockwise() {
                this._state.forEach(function(row) {
                    return row.reverse();
                });
                this.transpose();
            }
        },
        {
            // #endregion
            /**
   * Updates the game status based on the current game state.
   *
   * - If no move is possible, the {@link Game._status|game status}
   *  is set to `Lost`.
   * - If the board contains the number 2048, the game status is set to `Won`.
   *
   * @returns {void}
   */ key: "updateGameStatus",
            value: function updateGameStatus() {
                if (!this.checkMovePossibility()) {
                    this._status = Game.STATUS.Lost;
                    return;
                }
                var hasWon = this._state.some(function(row) {
                    return row.includes(2048);
                });
                if (hasWon) this._status = Game.STATUS.Won;
            }
        },
        {
            /**
   * Returns a random value, either 2 or 4, with a 90% chance of getting 2.
   *
   * @returns {number} 2 or 4, depending on the random chance.
   */ key: "getTwoOrFour",
            value: function getTwoOrFour() {
                return Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            /**
   * Places a new tile (either 2 or 4) in a random empty cell on the game board.
   * The tile is placed in a cell where the current value is 0.
   * If there are no empty cells, no tile is placed.
   */ key: "placeNewTile",
            value: function placeNewTile() {
                var emptyCells = [];
                for(var row = 0; row < this.size; row++){
                    for(var col = 0; col < this.size; col++)if (this._state[row][col] === 0) emptyCells.push({
                        row: row,
                        col: col
                    });
                }
                if (emptyCells.length > 0) {
                    var randomCellIndex = Math.floor(Math.random() * emptyCells.length);
                    var _emptyCells_randomCellIndex = emptyCells[randomCellIndex], row1 = _emptyCells_randomCellIndex.row, col1 = _emptyCells_randomCellIndex.col;
                    this._state[row1][col1] = this.getTwoOrFour();
                }
            }
        },
        {
            /**
   * Checks whether a move is possible in the current game state.
   *
   * A move is possible if:
   * - There is at least one empty cell (value of 0).
   * - Or if there are two adjacent cells (horizontally or vertically)
   * with the same value.
   *
   * @returns {boolean} `true` if a move is possible, otherwise `false`.
   */ key: "checkMovePossibility",
            value: function checkMovePossibility() {
                for(var row = 0; row < this.size; row++)for(var col = 0; col < this.size; col++){
                    var cell = this._state[row][col];
                    if (!cell) return true;
                    if (col < this.size - 1 && this._state[row][col + 1] === cell) return true;
                    if (row < this.size - 1 && this._state[row + 1][col] === cell) return true;
                }
                return false;
            }
        }
    ], [
        {
            key: "sanitizeState",
            value: // #region utility
            /**
   * Sanitizes the game state by ensuring that all values are either 0 or
   * a power of two. Optionally, forces values to the nearest lower power
   * of two.
   *
   * - If `forcePowerOfTwo` is `true`, each value will be replaced with the
   * nearest lower power of two.
   * - If `forcePowerOfTwo` is `false`, only values that are already powers
   * of two are kept, and others are set to 0.
   *
   * @param {number[][]} state - The 2D array representing the initial state
   * of the game board passed as parameter to a constructor.
   * @param {boolean} [forcePowerOfTwo=false] - Whether to force each value
   * to be the nearest lower power of two. Defaults to `false`.
   * @returns {number[][]} A sanitized 2D array with all values being either
   * 0 or a power of two.
   */ function sanitizeState(state) {
                var forcePowerOfTwo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var isPowerOfTwo = function(n) {
                    return n > 0 && (n & n - 1) === 0;
                };
                var getNearestLowerPowerOfTwo = function(n) {
                    if (n <= 0) return 0;
                    return Math.pow(2, Math.floor(Math.log2(n)));
                };
                var sanitizeValue = function(val) {
                    if (forcePowerOfTwo) return getNearestLowerPowerOfTwo(val);
                    return isPowerOfTwo(val) ? val : 0;
                };
                return state.map(function(row) {
                    return row.map(sanitizeValue);
                });
            }
        }
    ]);
    return Game;
}();
/**
   * Default number of starting tiles.
   * @readonly
   * @const
   * @type {number}
   */ (0, $cd5a47cf8ef6d766$export$71511d61b312f219)($3d28d7f1aac198f5$var$Game, "START_TILES_QUANTITY_DEFAULT", 2);
/**
   * The default board configuration (a 4x4 grid of zeros).
   * @readonly
   * @const
   * @type {number[][]}
   */ (0, $cd5a47cf8ef6d766$export$71511d61b312f219)($3d28d7f1aac198f5$var$Game, "DEFAULT_BOARD", [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
]);
/**
   * List of keys that represent movement directions.
   * @readonly
   * @const
   * @type {Array<string>}
   */ (0, $cd5a47cf8ef6d766$export$71511d61b312f219)($3d28d7f1aac198f5$var$Game, "MOVE_KEYS", Object.freeze([
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown'
]));
/**
   * Enum for the status of the game.
   * - `Idle`: The game has not started and is idling.
   * - `Playing`: The game has started and is in progress.
   * - `Lost`: The game has finished and the player lost.
   * - `Won`: The game has finished and the player won.
   *
   * @readonly
   * @enum {string}
   */ (0, $cd5a47cf8ef6d766$export$71511d61b312f219)($3d28d7f1aac198f5$var$Game, "STATUS", Object.freeze({
    Idle: 'idle',
    Playing: 'playing',
    Lost: 'lose',
    Won: 'win'
}));
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


// initialize the game with parameters:
/**
 * const game = new Game({
      startTilesAmount: 5,
      initialState: [
        [0, 0, 0, 0],
        [0, 4, 0, 0],
        [0, 0, 9, 0],
        [0, 0, 0, 2],
      ],
      forcePowerOfTwo: true,
});
 */ var $197cd56b15c33885$var$initialState = [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
];
var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports({
    initialState: $197cd56b15c33885$var$initialState
});
var $197cd56b15c33885$var$gameContainer = document.querySelector('.container');
var $197cd56b15c33885$var$actionButton = $197cd56b15c33885$var$gameContainer.querySelector('.controls button');
var $197cd56b15c33885$var$scoreInfo = $197cd56b15c33885$var$gameContainer.querySelector('.controls .info');
var $197cd56b15c33885$var$scoreNumberField = $197cd56b15c33885$var$gameContainer.querySelector('.controls .game-score');
var $197cd56b15c33885$var$gameGrid = $197cd56b15c33885$var$gameContainer.querySelector('.game-field tbody');
var $197cd56b15c33885$var$messageStart = $197cd56b15c33885$var$gameContainer.querySelector('.message-start');
var $197cd56b15c33885$var$messageWin = $197cd56b15c33885$var$gameContainer.querySelector('.message-win');
var $197cd56b15c33885$var$messageLose = $197cd56b15c33885$var$gameContainer.querySelector('.message-lose');
function $197cd56b15c33885$var$renderGame() {
    $197cd56b15c33885$var$updateScoreDisplay();
    $197cd56b15c33885$var$updateGameBoard();
    $197cd56b15c33885$var$updateGameStatusMessage();
}
function $197cd56b15c33885$var$updateScoreDisplay() {
    $197cd56b15c33885$var$scoreNumberField.textContent = $197cd56b15c33885$var$game.getScore();
}
function $197cd56b15c33885$var$updateGameStatusMessage() {
    var gameStatus = $197cd56b15c33885$var$game.getStatus();
    var isGameIdle = gameStatus === $3d28d7f1aac198f5$exports.STATUS.Idle;
    $197cd56b15c33885$var$messageStart.classList.add($197cd56b15c33885$var$CLASSNAME.Hidden);
    $197cd56b15c33885$var$messageWin.classList.add($197cd56b15c33885$var$CLASSNAME.Hidden);
    $197cd56b15c33885$var$messageLose.classList.add($197cd56b15c33885$var$CLASSNAME.Hidden);
    $197cd56b15c33885$var$actionButton.classList.remove($197cd56b15c33885$var$CLASSNAME.Restart, $197cd56b15c33885$var$CLASSNAME.Start);
    $197cd56b15c33885$var$actionButton.classList.add(isGameIdle ? $197cd56b15c33885$var$CLASSNAME.Start : $197cd56b15c33885$var$CLASSNAME.Restart);
    $197cd56b15c33885$var$actionButton.textContent = isGameIdle ? $197cd56b15c33885$var$LABEL.Start : $197cd56b15c33885$var$LABEL.Restart;
    switch(gameStatus){
        case $3d28d7f1aac198f5$exports.STATUS.Idle:
            $197cd56b15c33885$var$messageStart.classList.remove($197cd56b15c33885$var$CLASSNAME.Hidden);
            break;
        case $3d28d7f1aac198f5$exports.STATUS.Won:
            $197cd56b15c33885$var$messageWin.classList.remove($197cd56b15c33885$var$CLASSNAME.Hidden);
            break;
        case $3d28d7f1aac198f5$exports.STATUS.Lost:
            $197cd56b15c33885$var$messageLose.classList.remove($197cd56b15c33885$var$CLASSNAME.Hidden);
            break;
    }
}
function $197cd56b15c33885$var$updateGameBoard() {
    var grid = $197cd56b15c33885$var$game.getState();
    var numRows = $197cd56b15c33885$var$gameGrid.rows.length;
    var numCols = $197cd56b15c33885$var$gameGrid.rows[0].cells.length;
    for(var rowIndex = 0; rowIndex < numRows; rowIndex++)for(var colIndex = 0; colIndex < numCols; colIndex++){
        var cell = $197cd56b15c33885$var$gameGrid.rows[rowIndex].cells[colIndex];
        var value = grid[rowIndex][colIndex];
        cell.textContent = value || '';
        cell.className = "field-cell ".concat(value ? "field-cell--".concat(value) : '');
    }
}
document.addEventListener('keydown', function(ev) {
    var gameStatus = $197cd56b15c33885$var$game.getStatus();
    var validKeyPressed = $3d28d7f1aac198f5$exports.MOVE_KEYS.includes(ev.key);
    if (!validKeyPressed) return;
    ev.preventDefault();
    if (gameStatus === $3d28d7f1aac198f5$exports.STATUS.Playing) {
        $197cd56b15c33885$var$game.move(ev.key);
        $197cd56b15c33885$var$renderGame();
    }
});
$197cd56b15c33885$var$actionButton.addEventListener('click', function() {
    if ($197cd56b15c33885$var$game.getStatus() === $3d28d7f1aac198f5$exports.STATUS.Idle) $197cd56b15c33885$var$game.start();
    else $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$renderGame();
});
$197cd56b15c33885$var$scoreInfo.addEventListener('click', function() {
    // eslint-disable-next-line no-console
    console.log($197cd56b15c33885$var$game.getState());
});
$197cd56b15c33885$var$renderGame();

})();
//# sourceMappingURL=2048.9ab0b50e.js.map
